// extracted by mini-css-extract-plugin
export default {"options_parent":"SearchBar_options_parent__Kubmd","options_box":"SearchBar_options_box__jqQ3A"};